"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchableListDialog = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var filterHooks_1 = require("../../../hooks/filterHooks");
var SearchHooks_1 = require("../../../hooks/search/SearchHooks");
var SearchableListDialog_static_1 = require("./SearchableListDialog.static");
var SearchableListDialog_style_1 = __importDefault(require("./SearchableListDialog.style"));
function useSearchableListDialog(_a) {
    var _b;
    var inputItems = _a.inputItems, noun = _a.noun, pluralNoun = _a.pluralNoun, fuzzyPair = _a.fuzzyPair, isLoading = _a.isLoading, orderItems = _a.orderItems, placeholder = _a.placeholder;
    var _c = __read((0, react_1.useState)(), 2), searchedIds = _c[0], setSearchedIds = _c[1];
    var _d = __read((0, react_1.useState)(''), 2), searchText = _d[0], setSearchText = _d[1];
    var _e = __read((0, react_1.useState)(64), 2), height = _e[0], setHeight = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), isContentAtBottom = _f[0], setIsContentAtBottom = _f[1];
    var virtuosoRef = (0, react_1.useRef)(null);
    (0, SearchHooks_1.useFuzzySearch)({
        values: inputItems,
        fuzzyPair: fuzzyPair,
        searchText: searchText,
        setSearchedIds: setSearchedIds,
    });
    var items = (0, filterHooks_1.useSearchedAndFilteredItems)({ items: inputItems, searchedIds: searchedIds, filteredIds: undefined });
    var orderedItems = (0, react_1.useMemo)(function () { return (searchedIds || !orderItems ? items : orderItems(items)); }, [items, orderItems, searchedIds]);
    (0, react_1.useEffect)(function () {
        (0, lodash_1.debounce)(function () {
            var _a;
            (_a = virtuosoRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0 });
        }, 100)();
    }, [searchText]);
    var title = pluralNoun || noun + 's';
    var searchPlaceholder = isLoading
        ? SearchableListDialog_static_1.localText.placeholderLoading(title)
        : (_b = placeholder === null || placeholder === void 0 ? void 0 : placeholder((inputItems.length === 1 ? noun : title).toLowerCase(), inputItems.length)) !== null && _b !== void 0 ? _b : SearchableListDialog_static_1.localText.placeholder(inputItems.length, noun, pluralNoun);
    return {
        classes: (0, SearchableListDialog_style_1.default)(),
        height: height,
        isContentAtBottom: !orderedItems.length || isLoading || isContentAtBottom,
        orderedItems: orderedItems,
        searchPlaceholder: searchPlaceholder,
        searchText: searchText,
        setHeight: setHeight,
        setIsContentAtBottom: setIsContentAtBottom,
        setSearchText: setSearchText,
        title: title,
        virtuosoRef: virtuosoRef,
    };
}
exports.useSearchableListDialog = useSearchableListDialog;
